import React from 'react';
import './NoPermission.less';
// import { WarningOutlined } from '@ant-design/icons';

export default function NoPermission() {
    return (
        <div className="no-permission">
            <i className="bi bi-exclamation-triangle-fill" /> &nbsp;抱歉，您没有权限访问
        </div>
    );
}
